/**
 * DynamicLocator
 *
 * @module DynamicLocator
 * Api https://developers.google.com/maps/documentation/javascript/reference/3/map
 *
 */
;(function DynamicLocator() {
    /**
     * Build a Map with markers
     * @param {HTMLElement} $wrapper
     * @param Creaton.DynamicFilter cdynamicFilter
     * @param Creaton.CountryFilter countryFilter
     * @constructor
     */
    function ExpertsLocatorMap($wrapper, dynamicFilter, countryFilter) {
        var _this = this

        /**
         * Path of the static resources
         * @type {string}
         */
        var resourcePath = $wrapper.getAttribute('data-td-locator-resourcepath')

        /**
         * The container which is used for map rendering
         * @type {HTMLElement}
         */
        var mapContainer = $wrapper.querySelector('[data-expert="dynamic-map-container"]')

        /**
         * Define google autocomplete globally
         * @type {Object}
         */
        var autocomplete

        /**
         * Default zoom configuration
         * @type {Number}
         */
        var zoom = 13

        /**
         * Define google LatLngBounds globally
         * @type {Object}
         */
        var latlngbounds

        /**
         * Define google Map globally
         * @type {Object}
         */
        var map

        /**
         * Holds the current MarkerClusterer of Google Map
         */
        var markerCluster

        /**
         * @type {boolean}
         */
        var isFirstRequest = true

        /**
         * initial lat value, which is editable in the backend
         * @type {float}
         */
        var defaultLat = parseFloat(
            $wrapper.querySelector('[data-expert-type="dynamic-map-search"]').getAttribute('data-expert-default-lat')
        )

        /**
         * initial lat value, which is editable in the backend
         * @type {float}
         */
        var defaultLong = parseFloat(
            $wrapper.querySelector('[data-expert-type="dynamic-map-search"]').getAttribute('data-expert-default-long')
        )

        /**
         * initial zoom value, which is configurable in the backend
         * @type {int}
         */
        var defaultZoom = parseInt(
            $wrapper.querySelector('[data-expert-type="dynamic-map-search"]').getAttribute('data-expert-default-zoom')
        )

        /**
         * The info window
         * @type {Object}
         */
        var infoWindow

        /**
         * The prototype for the infoWindow content
         * @type {Dom}
         */
        var infoWindowContentTemplate

        /**
         * The prototype for the dynamicMapResultListWrapper
         * @type {Dom}
         */
        var dynamicMapResultListWrapper

        /**
         * The prototype for the resultList content
         * @type {Dom}
         */
        var resultListContentTemplate

        /**
         * The prototype for the noResultFound
         * @type {Dom}
         */
        var noResultFoundTemplate

        /**
         * Builds a map with markers
         * @method init
         * @constructor
         */
        this.init = function () {
            _this.initMap()
            _this.autoComplete()
            infoWindowContentTemplate = document.querySelectorAll('[data-expert-type="dynamic-map-infowindow"]')[0]
            dynamicMapResultListWrapper = document.querySelectorAll(
                '[data-expert-type="dynamic-map-result-list-wrapper"]'
            )[0]
            resultListContentTemplate = document.querySelectorAll('[data-expert-type="dynamic-map-result-list"]')[0]
            noResultFoundTemplate = document.querySelector('.dynamic-map-no-result-found')
            resultListContentTemplate.parentNode.removeChild(resultListContentTemplate)
            infoWindowContentTemplate.parentNode.removeChild(infoWindowContentTemplate)
        }

        /**
         * Initializes the map
         * @method initMap
         * @returns {void}
         */
        this.initMap = function () {
            map = new google.maps.Map(mapContainer, {
                zoom: defaultZoom,
                center: { lat: defaultLat, lng: defaultLong },
                scrollwheel: true,
            })

            latlngbounds = new google.maps.LatLngBounds()
            latlngbounds.extend(new google.maps.LatLng(defaultLat, defaultLong))

            infoWindow = new google.maps.InfoWindow({
                content: '',
            })

            google.maps.event.addListenerOnce(map, 'idle', function () {
                _this.loadResultList()
                _this.injectFakeCenteredMarker()

                // build the markers
                _this.loadMarker(function () {
                    // center the map after the markers have been loaded
                    map.fitBounds(latlngbounds)

                    google.maps.event.addListener(map, 'zoom_changed', function () {
                        // build the markers
                        _this.loadMarker()
                        _this.loadResultList()
                    })
                    google.maps.event.addListener(map, 'dragend', function () {
                        // build the markers
                        _this.loadMarker()
                        _this.loadResultList()
                    })
                })
            })
        }

        /**
         * Builds the google autocomplete service
         *
         * @method autoComplete
         * @returns {void}
         */
        this.autoComplete = function () {
            var places = new google.maps.places.PlacesService(map)
            autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
                types: ['(regions)'],
            })

            autocomplete.bindTo('bounds', map)
            autocomplete.addListener('place_changed', _this.onPlaceChanged)

            $('[data-expert-type="dynamic-map-button"]').click(function () {
                _this.onPlaceChanged()
            })
        }

        /**
         * Calculates the distance between two latlng locations in km.
         * This function is idedical as private function 'MarkerClusterer.prototype.distanceBetweenPoints_'
         * @param {google.maps.LatLng} p1 The first lat lng point.
         * @param {google.maps.LatLng} p2 The second lat lng point.
         * @return {number} The distance between the two points in km.
         *
         */
        this.getDistanceBetweenPoints = function (p1, p2) {
            if (!p1 || !p2) {
                return 0
            }

            var R = 6371 // Radius of the Earth in km
            var dLat = ((p2.lat() - p1.lat()) * Math.PI) / 180
            var dLon = ((p2.lng() - p1.lng()) * Math.PI) / 180
            var a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos((p1.lat() * Math.PI) / 180) *
                    Math.cos((p2.lat() * Math.PI) / 180) *
                    Math.sin(dLon / 2) *
                    Math.sin(dLon / 2)
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
            var d = R * c
            return d
        }

        /**
         *
         * @method injectFakeCenteredMarker
         * @returns {void}
         */
        this.injectFakeCenteredMarker = function () {
            var mapWrapper = document.querySelectorAll('[data-expert="map-wrapper"]')[0]
            var node = document.createElement('div')
            node.className = 'dynamic-map-fake-centered-marker'
            mapWrapper.appendChild(node)
        }

        /**
         *
         * @method renderNoResultFoundTemplate
         * @param {Object} obj
         * @returns {void}
         */
        this.renderNoResultFoundTemplate = function (data) {
            // Control the visibility of noResultFoundTemplate
            if (data.length == 0) {
                noResultFoundTemplate.style.display = 'block'
            } else {
                noResultFoundTemplate.style.display = 'none'
            }
        }

        /**
         *
         * @method highlightActiveResultList
         * @param {String} id
         * @returns {void}
         */
        this.highlightActiveResultList = function (id) {
            var allResultLists = document.querySelectorAll('[data-expert-type="dynamic-map-result-list"]')
            for (var i = 0; i < allResultLists.length; i++) {
                allResultLists[i].classList.remove('active')
            }

            // if something not working well,  check the JavaScript Hoisting
            var targetResultList = document.querySelectorAll('[data-expert-result-list-id="' + id + '"]')[0]
            targetResultList.classList.add('active')
        }

        /**
         *
         * @method loadResultList
         * @returns {void}
         */
        this.loadResultList = function () {
            var bounds = map.getBounds()
            var filters = {
                countries: countryFilter.getActiveFilters(),
                dynamicFilters: dynamicFilter.getActiveFilters(),
            }
            return window.CreatonExperts.DataProvider.resultListByAjax(
                bounds.getSouthWest().lat(),
                bounds.getSouthWest().lng(),
                bounds.getNorthEast().lat(),
                bounds.getNorthEast().lng(),
                filters,
                function (data) {
                    // use the data of the first request to initialize the country select
                    if (isFirstRequest) {
                        _this.initializeCountrySelection(data)
                        _this.initializeDynamicFilterSelection(data)
                        isFirstRequest = false
                    }
                    var modifiedData = _this.mergeDistanceIntoData(data)
                    var sortedData = _this.sortDataByDistance(modifiedData)
                    _this.renderResultList(sortedData)

                    // set src of image to prevent 404 error while resultListContentTemplate is active with placeholder of data-src
                    var imageElements = dynamicMapResultListWrapper.querySelectorAll('[data-src]')
                    imageElements.forEach(function (image) {
                        var source = image.getAttribute('data-src')
                        if (source && source !== 'undefined' && source !== 'companyImage') {
                            image.setAttribute('src', image.getAttribute('data-src'))
                        } else {
                            image.remove()
                        }
                    })
                }
            )
        }

        /**
         * Set data and callback for country select
         * @param data
         */
        this.initializeCountrySelection = function (data) {
            // the given callback is called whenever a country is selected
            countryFilter.init(data, function () {
                _this.loadMarker()
                _this.loadResultList()
            })
        }

        /**
         * Set data and callback for filter select
         * @param data
         */
        this.initializeDynamicFilterSelection = function (data) {
            // the given callback is called whenever a country is selected
            dynamicFilter.init(data, function () {
                _this.loadMarker()
                _this.loadResultList()
            })
        }

        /**
         *
         * @method mergeDistanceIntoData
         * @param {Object} data
         * @returns {object}
         */
        this.mergeDistanceIntoData = function (data) {
            var centerdLatLng = map.getCenter()
            var mergedData = []
            for (var i = 0; i < data.length; i++) {
                var currentItemLatlng = new google.maps.LatLng(data[i].latitude, data[i].longitude)
                var distance = _this.getDistanceBetweenPoints(centerdLatLng, currentItemLatlng)
                var roundedDistance = Math.round(distance)
                data[i]['distance'] = distance
                data[i]['roundedDistance'] = roundedDistance
                mergedData.push(data[i])
            }
            return mergedData
        }

        /**
         *
         * @method sortDataByDistance
         * @param {Object} data
         * @returns {object}
         */
        this.sortDataByDistance = function (data) {
            var sortedData
            sortedData = data.sort(function (a, b) {
                return a.distance - b.distance
            })
            return sortedData
        }

        /**
         * Calls the DataProvider, builds the Resultlist
         *
         * @method renderResultList
         * @param {Object} data
         * @returns {void}
         */
        this.renderResultList = function (data) {
            var resultListContent = resultListContentTemplate.cloneNode(true)
            var resultListHtml = ''
            for (var i = 0; i < data.length; i++) {
                var currentItemTemplate = resultListContent.outerHTML.replace(
                    /{{{?(#[a-z]+ )?[a-z]+.[a-z]*}?}}/gm,
                    function (match, contents, offset, input_string) {
                        // slice the property path
                        var propertyPath = match.slice(2, match.length - 2)

                        // try to find the data in the given object
                        try {
                            return _this.getObjectValueByPath(data[i], propertyPath)
                        } catch (e) {
                            return ''
                        }
                    }
                )
                resultListHtml = resultListHtml + currentItemTemplate
            }

            dynamicMapResultListWrapper.innerHTML = resultListHtml
            _this.renderNoResultFoundTemplate(data)
        }

        /**
         * Calls the DataProvider, builds the marker
         *
         * @method loadMarker
         * @returns {Object}
         */
        this.loadMarker = function (markerAddedCallBack) {
            var bounds = map.getBounds()

            var filters = {
                countries: countryFilter.getActiveFilters(),
                dynamicFilters: dynamicFilter.getActiveFilters(),
            }

            return window.CreatonExperts.DataProvider.markerByAjax(
                bounds.getSouthWest().lat(),
                bounds.getSouthWest().lng(),
                bounds.getNorthEast().lat(),
                bounds.getNorthEast().lng(),
                filters,
                function (markerData, newMarkerStatus) {
                    var markers = []

                    // Needs to be executed for every request since there could be new countries
                    countryFilter.renderCountrySelection(markerData)
                    dynamicFilter.renderFilterSelection(markerData)

                    if (newMarkerStatus) {
                        markerData.map(function (markerData) {
                            latlngbounds.extend(new google.maps.LatLng(markerData.latitude, markerData.longitude))
                            var marker = new google.maps.Marker({
                                position: { lat: markerData.latitude, lng: markerData.longitude },
                                visible: true,
                                map: map,
                            })
                            marker.addListener('click', function () {
                                infoWindow.setContent(_this.renderInfoWindowContent(markerData))
                                infoWindow.open(map, marker)
                                _this.highlightActiveResultList(markerData.expertId)
                            })
                            markers.push(marker)
                        })
                    }

                    if (markerCluster !== undefined) {
                        // Since in some cases markers are removed from the map (country filters)
                        // The markers need to be emptied every time
                        // This could be improved by removing only the markers, that need to be removed, if loading speed is to slow
                        markerCluster.clearMarkers()
                    }

                    markerCluster = new MarkerClusterer(map, markers, { imagePath: resourcePath + 'm' })

                    if (typeof markerAddedCallBack == 'function') {
                        return markerAddedCallBack()
                    }
                }
            )
        }

        /**
         * Returns the value ob the object by given path like (properties.myproperty)
         * @param {Object} obj
         * @param {String} path
         * @returns {*}
         */
        this.getObjectValueByPath = function (obj, path) {
            for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                obj = obj[path[i]]
            }
            return obj
        }

        /**
         * Renders the content for a infoWindow with the given markerData. Replaces "handlebar" engine like simple markers with the markerdata {{city}}
         * @param {Object} markerData
         * @returns {Dom}
         */
        this.renderInfoWindowContent = function (markerData) {
            // clone the template
            var infoWindowContent = infoWindowContentTemplate.cloneNode(true)
            // replace all markers like {{my.property.in.markerData}} with the data of markerData
            return infoWindowContent.outerHTML.replace(
                /{{{?(#[a-z]+ )?[a-z]+.[a-z]*}?}}/gm,
                function (match, contents, offset, input_string) {
                    // slice the property path
                    var propertyPath = match.slice(2, match.length - 2)
                    // try to find the data in the given object
                    try {
                        return _this.getObjectValueByPath(markerData, propertyPath)
                    } catch (e) {
                        return ''
                    }
                }
            )
        }

        /**
         *
         * @method onPlaceChanged
         * @returns {void}
         */
        this.onPlaceChanged = function () {
            var place = autocomplete.getPlace()
            // If the user does not use the autosuggest
            if (!place || !place.geometry) {
                _this.callGeoCoderAPI()
            } else {
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport)
                } else {
                    map.setCenter(place.geometry.location)
                    map.setZoom(zoom)
                }
            }
        }

        /**
         * Process of converting addresses into geographic coordinates
         *
         * @method callGeoCoderAPI
         * @returns {void}
         */
        this.callGeoCoderAPI = function () {
            var firstResult = $('.pac-item:first').text()

            var geocoder = new google.maps.Geocoder()
            geocoder.geocode({ address: firstResult }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (results[0].geometry.viewport) {
                        map.fitBounds(results[0].geometry.viewport)
                    } else {
                        map.setCenter(results[0].geometry.location)
                        map.setZoom(zoom)
                    }
                }
            })
        }

        /**
         * initialize call
         */
        _this.init()
    }

    if (typeof document.addEventListener === 'function') {
        document.addEventListener('Creaton.Experts.apiInitialized', function (event) {
            var mapsDom = document.querySelectorAll('[data-expert-type="dynamic-map"]')
            // iterate all map instances
            Array.prototype.forEach.call(mapsDom, function (mapDom, i) {
                var countryFilter = new window.CreatonExperts.CountryFilter()
                var dynamicFilter = new window.CreatonExperts.DynamicFilter()
                var mapModule = new ExpertsLocatorMap(mapDom, dynamicFilter, countryFilter)
            })
        })
    }
})()
